<template>
  <div class="select-ref">
    <div class="left">
      <el-select
        :value="showValue"
        filterable
        remote
        :remote-method="search"
        :loading="loading"
        :disabled="disabled"
        placeholder="请选择或搜索"
        class="is-select"
        @input="selectChange"
        @visible-change="visibleChange"
        @keydown.enter.native="selectFirst"
        multiple
        value-key="value"
        clearable
        :size="size"
      >
        <el-option
          style="height:100%"
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          <span
            style="white-space: normal;line-height: 17px;display: inline-flex;word-break: break-all;width:280px"
          >
            {{ item.label }}
          </span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { getSheetViewData } from "@/api/sheet/sheetView"
import { getSheet } from "@/api/sheet/sheet"

export default {
  name: "select-ref",
  props: {
    disabled: Boolean,
    value: {
      type: Array,
      default: () => []
    },
    control: {
      type: Object,
      default: () => ({})
    },
    sheetDataServer: Object,
    size: String
  },
  data() {
    return {
      searchText: "",
      loading: false,
      list: [],
      getRefDataDebounced: this._.debounce(this.getRefData, 300),
      refSheet: {}
    }
  },
  computed: {
    showValue() {
      return this.value.map(item => item.value)
    },
    options() {
      return this._.isEmpty(this.list) ? this.value : this.list
    },
    showFields() {
      return this.control.searchFields?.length
        ? this.control.searchFields
        : this.control.fields?.length
        ? this.control.fields
        : [(this.refSheet.controls || []).find(control => control.main)?._cid]
    },
    searchBody() {
      return {
        searchText: this.searchText,
        searchCids: this.showFields
      }
    },
    refCondition() {
      if (!this.sheetDataServer) return {}
      return {
        refSheetId: this.sheetDataServer.sheetId,
        refControlId: this.control?._cid,
        refSheetData: this.sheetDataServer
      }
    }
  },
  watch: {
    control: {
      immediate: true,
      handler(control) {
        if (!control) return
        const { refSheetId } = control
        getSheet(refSheetId).then(sheet => {
          this.refSheet = sheet
        })
      }
    }
  },
  methods: {
    getRefData() {
      this.loading = true
      return getSheetViewData({
        sheetId: this.control.refSheetId,
        ...this.searchBody,
        ...this.refCondition,
        page: 1,
        size: 20
      }).then(res => {
        this.list = res.content.map(sheetData => ({
          value: sheetData.id,
          label:
            this.showFields
              .map(cid => sheetData.data[cid])
              .filter(t => t)
              .join(" / ") || "空"
        }))
        this.loading = false
      })
    },
    search(searchText) {
      this.searchText = this._.trim(searchText)
      this.loading = true
      this.getRefDataDebounced()
    },
    visibleChange(visible) {
      if (visible) {
        this.loading = true
        this.getRefDataDebounced()
      }
    },
    selectChange(selectedVal) {
      this.$emit("input", selectedVal)
      this.searchText = ""
    },
    selectFirst() {
      let filterList = this.list?.filter(item => !this.showValue.includes(item.value)) || []
      if (!this._.isEmpty(filterList)) {
        let first = filterList[0]
        this.value.push(first.value)
      }
      this.$emit("input", this.value)
      this.searchText = ""
    }
  }
}
</script>

<style lang="scss" scoped>
.select-ref {
  display: flex;
  min-height: 32px;
  align-items: flex-start;
  .left {
    flex: auto;
    height: 100%;
    &.show-ref {
      .is-select {
        ::v-deep .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
      .is-text {
        border-radius: 4px 0 0 4px;
      }
    }
    .is-select {
      width: 100%;
      ::v-deep .el-input__inner {
        border-radius: 4px;
      }
    }
    .is-text {
      @include ellipsis;
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 11px;
      border-radius: 4px;
      white-space: pre-line;
      line-height: 1.4;
      padding: 4px 10px;
      border: 1px solid #d8dce6;
      box-sizing: border-box;
      color: $color-main;
      .icon-close {
        margin-left: auto;
        color: $color-font-second;
        .el-icon-close {
          padding: 4px;
          cursor: pointer;
          &:hover {
            color: $color-main;
          }
        }
      }
    }
  }
}
</style>
